import {post} from "aws-amplify/api";

async function GeoCode(advertiserId, userSuppliedName, keywordSearch){

    const geoCodeBody = {
        'advertiserId': advertiserId,
        'userSuppliedName': userSuppliedName,
        'userSuppliedList': [keywordSearch]
    }

    try {
        const restOperation = post({
            apiName: 'Catalytics_STAGING_API',
            path: '/geocoding',
            options: {
                body: geoCodeBody,
            },
            headers: {
                ContentType: 'application/json',
            }
        });
        const {body} = await restOperation.response;
        const response = await body.json();
        return response;
    } catch (e) {

    }
}

export default GeoCode;